import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Subscription from "../../../lib/Subscription";
import { checkChoices } from "../../Bikefit/lib/bikefit";
import Progress from "../Progress";
import IntegrationOption from "./IntegrationOption";
import { goTo as goToBikefit, startFromBikefinder } from "../../../redux/actions/bikefit";
import bikeTypeSupportsFitting from "../FittingSupport";
import {selectBikefitChoices} from "../../../redux/selectors/bikefit";

function Integration(
  {
    chosenIntegrationOption,
    goTo,
    setChosenIntegrationOption,
    get,
    measure,
    mtbType,
    post,
    setMeasureBikefit,
    parcourType,
    setSavedResults,
    traject
  }
) {
  const [t] = useTranslation("integration");
  const dispatch = useDispatch();
  const [isBikefitActive, setBikefitActive] = useState(false);
  const [isBikefitAdvice, setBikefitAdvice] = useState(false);
  const choices = useSelector(selectBikefitChoices);
  const lastResultChoices = JSON.parse(
    localStorage.getItem("last_result_choices")
  );

  let defaultActiveOption = "";
  switch (chosenIntegrationOption) {
    case "option1":
      defaultActiveOption = "first_option";
      break;
    case "option2":
      defaultActiveOption = "second_option";
      break;
    case "option3":
    default:
      defaultActiveOption = "third_option";
  }

  const [activeOption, setActiveOption] = useState(defaultActiveOption);

  const options = [
    {
      id: "first_option",
      key: "option1",
      title: t("Option_one_title"),
      contents: [
        t("Option_one_content1"),
        t("Option_one_content2"),
        t("Option_one_content3"),
      ],
    },
    {
      id: "second_option",
      key: "option2",
      title: t("Option_two_title"),
      contents: [t("Option_two_content1"), t("Option_two_content2")],
    },
    {
      id: "third_option",
      key: "option3",
      title: t("Option_three_title"),
      contents: [t("Option_three_content1"), t("Option_three_content2")],
    },
  ]

  const [showNewBikefit, setShowNewBikefit] = useState(true);
  const [showOldBikefit, setShowOldBikefit] = useState(true);

  useEffect(() => {
    Subscription.checkSubscription("bikefit").then((hasSubsription) => {
      setBikefitActive(hasSubsription);

      if (!hasSubsription) {
        setShowNewBikefit(false);
      }

      const correctChoicesAvailable = checkChoices(choices);
      setBikefitAdvice(correctChoicesAvailable);

      let oldBikefitActive = true;
      /// check if current flow is of type race or mbt and check if last old result is 1 same then show option 1 else nog
      if (! (lastResultChoices && sameBikeCat())) {
        setShowOldBikefit(false);
        oldBikefitActive = false
      }

      if (! (bikeTypeSupportsFitting(mtbType) && (hasSubsription || oldBikefitActive))) {
        setChosenIntegrationOption("option3")
        goTo("/advice/sizes", traject);
      }
    });
  }, [choices]);

  const sameBikeCat = () => {
    var bikeType = lastResultChoices.stepA.bikeType;


    return (
      (traject === "race" && bikeType === 1) ||
      (traject === "mtb" && bikeType === 2)
    );
  };

  function goBack(event) {
    event.preventDefault();
    goTo("/advice/gender", traject);
  }

  const goNext = (event) => {
    event.preventDefault();
    switch (activeOption) {
      case "first_option":
        setSavedResults(true);
        setMeasureBikefit();
        setChosenIntegrationOption("option1");
        goTo("/advice/price", traject);
        break;
      case "second_option":
        // routing should be with another redux function, like: bikefit/step2?bikefinder&mtb-cat=race&bike-type=xc
        setSavedResults(false);
        setMeasureBikefit();
        setChosenIntegrationOption("option2");
        dispatch(startFromBikefinder(traject, mtbType));
        dispatch(goToBikefit("stepB", "sittingPositionRoad"));

        break;
      case "third_option":
      default:
        setSavedResults(false);
        setChosenIntegrationOption("option3");
        goTo("/advice/sizes", traject);

        break;
    }
  };

  const changeOption = (id) => setActiveOption(id);

  let shownOptions = options;
  if (! showOldBikefit) {
    shownOptions = shownOptions.filter(option => option.key !== 'option1')
  }

  if (! showNewBikefit) {
    shownOptions = shownOptions.filter(option => option.key !== 'option2')
  }

  return isBikefitActive || isBikefitAdvice ? (
    <div className="container main">
      <Progress goTo={goTo} step={2} traject={traject} />
      <div className="col-12 text-center title">
        <h2> {t("Title")} </h2>
      </div>
      <form className="row parcourtype" onSubmit={goNext}>
        {shownOptions.map((option) => (
          <IntegrationOption
            key={option.id}
            title={option.title}
            contents={option.contents}
            active={option.id === activeOption}
            handleChange={() => changeOption(option.id)}
            id={option.id}
          />
        ))}

        <div className="col-6 text-left">
          <button className="back btn btn-link" onClick={goBack}>
            <i className="fas fa-caret-left"></i> {t("Back")}
          </button>
        </div>
        <div className="col-6 text-right">
          <input
            id="submitbtn"
            className="btn btn-secondary"
            type="submit"
            value={t("Next")}
          />
        </div>
      </form>
    </div>
  ) : (
    <React.Fragment></React.Fragment>
  );
}

export default Integration;
